import { Box, Button, ButtonBase, createTheme, CssBaseline, Grid, SwipeableDrawer, ThemeProvider, Typography } from '@mui/material'

import packingSlip from '../../images/hsp-plus/packing-slip.png'
import { generateTheme } from '../../providers/mui-theme-provider'
import { CONTACT_US_URL } from '../../utils/constants'
import useIsMobile from '../../utils/hooks/useIsMobile'
import BlurSkrim from '../blur-skrim'
import BasicDialog from '../m3/basic-dialog'

import classes from './index.styles'

interface IProps {
  open: boolean
  onClose: () => void
}

const FindOrderNumberDrawer = ({ open, onClose }: IProps) => {
  const isMobile = useIsMobile()

  const body = (
    <>
      <Typography variant="body1">Locate the order number on the packing slip included in your package (top left corner).</Typography>
      <Box component="img" src={packingSlip} alt="Packing slip with the order number highlighted in the top left corner" sx={classes.image} />
    </>
  )

  const actions = (
    <>
      <Button href={CONTACT_US_URL} target="_blank" rel="noopener noreferrer" variant="text">
        Help
      </Button>
      <Button variant="contained" disableElevation onClick={onClose}>
        OK, Got it
      </Button>
    </>
  )

  if (!isMobile) {
    return (
      <BasicDialog
        open={open}
        onClose={onClose}
        variant="hsp-plus"
        title="Find the Order Number"
        showCloseIcon={true}
        hideCancelButton={true}
        textContent={
          <Grid container={true} sx={classes.dialogBody}>
            {body}
          </Grid>
        }
        confirmButton={
          <Grid container={true} sx={classes.dialogActions}>
            {actions}
          </Grid>
        }
      />
    )
  }

  return (
    <ThemeProvider theme={createTheme(generateTheme('light'))}>
      <CssBaseline />
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        onOpen={() => undefined}
        slots={{
          backdrop: (backdropProps) => <BlurSkrim {...backdropProps} onClick={onClose} />,
        }}
        slotProps={{ paper: { sx: classes.paper } }}
      >
        <ButtonBase onClick={onClose} aria-label="Close" sx={classes.handleButton}>
          <Box sx={classes.handle} />
        </ButtonBase>

        <Grid container={true} sx={classes.content}>
          <Typography variant="subtitle2" component="h2" sx={classes.title}>
            Find the Order Number
          </Typography>
          {body}
        </Grid>

        <Grid container={true} sx={classes.actions}>
          {actions}
        </Grid>
      </SwipeableDrawer>
    </ThemeProvider>
  )
}

export default FindOrderNumberDrawer
